import React from "react";
import Content from "../components/layout/Content";

const about = ({ transition }) => (
  <div className="Shell" style={transition && transition.style}>
    <Content header>
      <div className="container">
        <article className="Article mb4">
          <header className="Article__header">
            <h2>Varför har vi tagit fram det här spelet?</h2>
          </header>
          <section className="Article__section">
            <p>
              Vi tror att arbetsgivare och arbetssökande vinner på att tydligt
              kunna uttrycka sina behov och vad de själva kan erbjuda.
            </p>

            <p>
              Vi vill visa på värdet i att uttrycka sig så precist som möjligt
              och undvika floskler. Beskriv gärna kompetenser du behöver för en
              viss roll som beteenden. Då har du större chans att locka rätt
              person till din organisation. Att hitta rätt kompetens handlar om
              att fråga efter rätt saker.
            </p>
            <br />
            <h2>Vårt arbete med pyramidanalysen</h2>
            <p>
              Idag förändras arbetsmarknaden snabbt. Människor behöver röra sig
              mellan olika branscher och yrken under ett arbetsliv. Både
              arbetsgivare och arbetssökande kan behöva bredda sina perspektiv
              och sätt att uttrycka sig. Vi vill stimulera det.
            </p>

            <p>
              Pyramidanalysen utgår ifrån arbetsmarknadens behov av kompetenser
              som är generella, det vill säga sådana som är användbara i många
              olika branscher. Vi har fört en dialog om generella kompetenser
              med 200 arbetsgivare och arbetssökande samt ett antal
              branschorganisationer. Utifrån detta och arbetspsykologisk kunskap
              har våra experter tagit fram denna enkla metod för behovsanalys.
            </p>
          </section>
          <br />
          <footer className="Article__footer">
            <h2>Kontakta oss</h2>
            <p>
              Vill du veta mer om hur vi arbetar med kompetenser?{" "}
              <a
                href="mailto:projektet-kompetensmatchning@arbetsformedlingen.se?subject=Jag vill veta mer arbetet med kompetenser"
                className="c-link"
              >
                Mejla oss
              </a>{" "}
              gärna. Eller{" "}
              <a
                className="c-link"
                href="https://docs.google.com/forms/d/e/1FAIpQLSfBcZulaFPtos0v5NC4WDbtCa77Q0k7n88LXp81Ig01vtyGdg/viewform"
              >
                skicka feeback
              </a>{" "}
              via vårt Google formulär.
            </p>
          </footer>
        </article>
      </div>
    </Content>
  </div>
);
export default about;



// WEBPACK FOOTER //
// ./src/pages/about.js